import { useState } from 'react';
import EDLink from '../../../../../../BaseComponents/Link/EDLink';
import { ResetPwdDialog } from './Components/ResetPwdDialog/ResetPwdDialog';

interface IProps {
  gas?: boolean;
  lokalt?: boolean;
  avenyId?: boolean;
  dbname?: string;
  email?: string;
}

/**
 * En länk som öppnar upp en dialog där man kan ange en epostadress och få ett nytt lösenord skickat
 */
const ResetPwdLink: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const enabled = props.gas || props.dbname;

  return (
    <>
      <EDLink
        buttonComponent={true}
        disabled={!enabled}
        hint="Klicka här för att få ett nytt lösenord"
        disabledReason={
          props.lokalt ? 'Välj databas' : 'Välj inloggningssystem'
        }
        onClick={event => {
          event.preventDefault();
          event.stopPropagation();
          setDialogOpen(true);
        }}
        testId="GlömdInloggning"
      >
        {props.children}
      </EDLink>
      <ResetPwdDialog
        open={dialogOpen}
        setOpen={setDialogOpen}
        gas={props.gas && !props.avenyId}
        dbname={props.dbname}
        email={props.email}
        key={dialogOpen.toString()}
      />
    </>
  );
};

export default ResetPwdLink;
